import {
  JSONPatchDocument,
  PagedResponse,
  QueryParams,
  ValidatedResponse,
} from "@ofqual/portal-core/core/types";
import {
  all,
  call,
  getContext,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { BusinessModel } from "../domain/BusinessModel";
export function* rootSaga() {}
